<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <h4 class="mb-sm-0">Sous-entité</h4>

        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item"><router-link :to="{ name: 'home' }">Tableau de bord</router-link></li>
            <li class="breadcrumb-item"><router-link :to="{ name: 'home' }">Configurations</router-link></li>
            <li class="breadcrumb-item active">Sous-entité</li>
          </ol>
        </div>

      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <form @submit.prevent="editCollectivite">
          <div class="card card-animate">

            <div class="card-body">
              <div class="row text-start">
                <div class="col-sm-12">
                  <label for="firstName" class="form-label">Nom</label>
                  <input v-model="ramification.nom" type="text" class="form-control" required>
                  <div class="invalid-feedback">Veuillez entrer le nom de la taxe</div>
                </div>
              </div>
              <div class="row text-start mt-3">
                <div class="col-sm-12">
                  <label for="firstName" class="form-label">Parent</label>
                  <select v-model="ramification.parent" type="text" class="form-control" required>
                    <option :key="item.id" :value="item.id" v-for="item in listParent">{{item.nom}} <span v-if="item.parent != null"> => {{item.parent.nom}}</span></option>
                  </select>
                  <div class="invalid-feedback">Veuillez entrer le nom de la taxe</div>
                </div>
              </div>
              <div class="row text-start mt-3">
                <div class="col-sm-12">
                  <label for="firstName" class="form-label">Type</label>
                  <select v-model="ramification.type" type="text" class="form-control" required>
                    <option :key="item.id" :value="item.id" v-for="item in listTypeRamification">{{item.nom}}</option>
                  </select>
                  <div class="invalid-feedback">Veuillez entrer le nom de la taxe</div>
                </div>
              </div>
              <div class="row text-start mt-3">
                <div class="col-sm-12">
                  <label for="firstName" class="form-label">Code</label>
                  <input v-model="ramification.code" type="text" class="form-control" disabled required>
                  <div class="invalid-feedback">Veuillez entrer le nom de la taxe</div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-12">
                  <div class="form-check form-switch form-switch-success">
                    <input  v-model="ramification.enabled" class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" >
                    Active ?
                  </div>
                </div>
              </div>

            </div>
            <div class="card-footer">
              <div class="row">
                <button type="submit" class="btn btn-primary">Enregistrer</button>

              </div>
            </div>
          </div>

        </form>

      </div>
    </div>
  </div>
</template>

<script>
import Ramification from "@/entity/Ramification";
import Repository from '@/repository/RamificationRepository'
import TypeRamificationRepository from '@/repository/TypeRamificationRepository'
import EntiteRepository from '@/repository/EntiteRepository'

export default {
  name: 'EditRamificationPage',
  data() {
    return {
      ramification: new Ramification(),
      repository: new Repository(),
      entiteRepository: new EntiteRepository(),
      typeRamificationRepo: new TypeRamificationRepository(),
      listTypeRamification: null,
      selectedEntite: null,
      listParent: null,


    }
  },
  computed: {
  },
  methods: {
    editCollectivite(){
      this.repository.edit(this.ramification, this.$route.params.id);
      this.$router.push({ name: 'listRamifications' })
    }

  },
  created() {
    this.repository.find(this.$route.params.id)
        .then(response => {
          this.ramification = response;
          this.ramification.type = response.type.id;
          this.ramification.entite = response.entite.id;
          this.ramification.parent = response.parent.id;
          //   console.log(this.listCollectivite);
        })
        .catch(error => {
          console.log(error);
        });
    this.typeRamificationRepo.search([{ colonne: '', operator: '', value: '' }], 'tr.nom', 'asc', 30, 1)
        .then(response => {
          this.listTypeRamification = response.data;
          //   console.log(this.listCollectivite);
        })
        .catch(error => {
          console.log(error);
        });
    this.repository.search([{ colonne: '', operator: '', value: '' }], 'ram.nom', 'asc', 3000, 1)
        .then(response => {
          this.listParent = response.data;
          //   console.log(this.listCollectivite);
        })
        .catch(error => {
          console.log(error);
        });
    this.entiteRepository.search([{ colonne: '', operator: '', value: '' }], 'ent.nom', 'asc', 30, 1)
        .then(response => {
          this.selectedEntite = response.data;
         // this.ramification.entite = response.data.id;
          //   console.log(this.listCollectivite);
        })
        .catch(error => {
          console.log(error);
        });


  }
}
</script>